import { Component, HostListener, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Namespace } from 'enums-lib';
import { DependenciesModelBuilderService } from '../../../services/dependencies-model-builder.service';

@Component({
    selector: 'app-scripting-box',
    templateUrl: './scripting-box.component.html',
    styleUrls: ['./scripting-box.component.scss'],
    standalone: false
})
export class ScriptingBoxComponent implements OnInit {
  @Input() clientNamespace: Namespace;
  @Input() formGroup: UntypedFormGroup;

  chipInputTooltip: string;
  compactCodeBox = false;

  constructor(private dependenciesModelBuilderService: DependenciesModelBuilderService) {}

  ngOnInit(): void {
    this.chipInputTooltip = `The path to the required dependency e.g. ${this.clientNamespace}.candidate.credentials`;
  }

  getDependencies(): string[] {
    return this.formGroup.get('dependencies').value;
  }

  addDependency(dependencyPath: string): void {
    this.formGroup.get('dependencies').markAsDirty();
    let model = this.formGroup.get('model').value;
    model = this.dependenciesModelBuilderService.insertInto(model, dependencyPath);
    this.formGroup.get('model').setValue(model);
  }

  removeDependency(removedPath: string): void {
    this.formGroup.get('dependencies').markAsDirty();

    // brute force rebuild of the model
    let model = {};
    this.getDependencies().forEach((dependencyPath) => {
      model = this.dependenciesModelBuilderService.insertInto(model, dependencyPath);
    });
    this.formGroup.get('model').setValue(model);
  }

  @HostListener('document:keydown.alt.c', ['$event'])
  protected handleKeydownEvent(event: KeyboardEvent): void {
    this.compactCodeBox = !this.compactCodeBox;
  }
}
